import { Box, Checkbox, FormControlLabel, Grid, Link, Paper, TextField, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import SyncIcon from "@material-ui/icons/Sync";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { FilesComponent } from "components/system";
import { Form, Formik } from "formik";
import MaterialTable from "material-table";
import { DropzoneArea } from "material-ui-dropzone";
import Labels from "../../../../lang/Labels_en";
import { getDesignationType, getTypeFromNameFile, handleFileType } from "../../../../utils/Utils";
import EnumDesignation from "../../../../utils/enum/EnumDesignation";
import HtmlTooltip from "../../../system/html-tooltip/HtmlTooltip";
import { tableIcons } from "../../../system/material-table-utils/MaterialTableUtils";
import { manuscriptFigures } from "../../manuscript/submit/TooltipText";
import TabUploadRevisionService, { TabUploadRevisionServiceType } from "./TabUploadRevisionService";
import useStyles from "./TabUploadRevisionStyle";

const SIZE_1MB = 1048576;

export default function TabUploadRevision({ article }: any) {
  const classes = useStyles();

  const {
    uploadFile,
    filesList,
    filesByDesignation,
    designationOptions,
    openDialog,
    handleOpenDialog,
    handleCloseDialog,
    handleResetDialog,
    files,
    uploading,
    submit,
    deleteFile,
    deleteFileGroup,
    selectedDesigantion,
    checkAllRelevantDoc,
    setCheckAllRelevantDoc,
    reuseFilesFromOldRevision,
  }: TabUploadRevisionServiceType = TabUploadRevisionService({ article });

  const letterOfRebutalDisable = filesList.some((f: any) => f.designation === EnumDesignation.LETTER_OF_REBUTAL);
  const markedManuscriptDisable = filesList.some((f: any) => f.designation === EnumDesignation.MARKED_MANUSCRIPTS);
  const unmarkedManuscriptDisable = filesList.some((f: any) => f.designation === EnumDesignation.UNMARKED_MANUSCRIPT);

  return (
    <div>
      <CssBaseline />
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography variant="h6">To do:</Typography>
          <Grid container direction="column">
            <FormControlLabel
              key={EnumDesignation.LETTER_OF_REBUTAL}
              disabled
              control={<Checkbox checked={letterOfRebutalDisable} readOnly={true} color="primary" />}
              label="A letter of rebuttal on all the comments of the reviewers and outlining all the changes point for point"
            />
            <FormControlLabel
              disabled
              key={EnumDesignation.MARKED_MANUSCRIPTS}
              control={<Checkbox checked={markedManuscriptDisable} readOnly={true} color="primary" />}
              label="A marked version of your revised manuscript, please use the line numbering function. Please ensure that you return your manuscript with the changes clearly marked (you can use the review function of Word)"
            />
            <FormControlLabel
              disabled
              key={EnumDesignation.UNMARKED_MANUSCRIPT}
              control={<Checkbox checked={unmarkedManuscriptDisable} readOnly={true} color="primary" />}
              label={"An unmarked version of the definite version of revised manuscript. "}
            />
            <FormControlLabel
              key={EnumDesignation.ADDITIONAL_FILE}
              disabled={!(letterOfRebutalDisable && markedManuscriptDisable && unmarkedManuscriptDisable)}
              control={
                <Checkbox
                  checked={checkAllRelevantDoc}
                  readOnly={true}
                  color="primary"
                  onClick={() => setCheckAllRelevantDoc(!checkAllRelevantDoc)}
                />
              }
              label="I confirm that all relevant and updated documents have been uploaded (figures, tables, videos, supplementary materials)"
            />
          </Grid>

          <MaterialTable
            icons={tableIcons}
            columns={[
              { title: Labels.FILE_NAME, field: "id", hidden: true },
              {
                title: Labels.FILE_NAME,
                field: "name",
                cellStyle: (data, rowData: any) => ({
                  color: rowData?.color,
                  maxWidth: "30%",
                }),
                render: (rowData: any) =>
                  [
                    EnumDesignation.MANUSCRIPT,
                    EnumDesignation.TABLES,
                    EnumDesignation.LETTER_OF_REBUTAL,
                    EnumDesignation.MARKED_MANUSCRIPTS,
                    EnumDesignation.UNMARKED_MANUSCRIPT,
                  ].includes(rowData?.designation) && rowData?.location ? (
                    <Link href={rowData?.location} color="inherit" component="a" target="_blank">
                      {rowData?.name}
                    </Link>
                  ) : [
                      EnumDesignation.FIGURE,
                      EnumDesignation.SUPPLEMENTARY_FIGURE,
                      EnumDesignation.ADDITIONAL_FILE,
                      EnumDesignation.VIDEO_FILE,
                    ].includes(rowData?.designation) && rowData?.files?.length > 0 ? (
                    <FilesComponent files={rowData.files} deleteFile={deleteFile} />
                  ) : (
                    rowData?.name
                  ),
              },
              {
                title: Labels.FILE_DESIGNATION,
                field: "designation",
                render: ({ tooltip, designation }: any) => (
                  <Box display="flex">
                    <Typography>{getDesignationType(designation, Labels)}</Typography>
                    {tooltip && (
                      <HtmlTooltip title={tooltip} interactive>
                        <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                      </HtmlTooltip>
                    )}
                  </Box>
                ),

                cellStyle: (data, rowData: any) => ({
                  color: rowData?.color,
                }),
              },
              {
                title: Labels.FILE_TYPE,
                field: "type",
                cellStyle: (data, rowData: any) => ({
                  color: rowData?.color,
                }),
              },
            ]}
            data={filesByDesignation}
            options={{
              actionsColumnIndex: -1,
              pageSize: 10,
              search: false,
            }}
            actions={[
              ({ showAdd, code }) => ({
                icon: () => <AddIcon color="action" />,
                tooltip: Labels.ADD,
                hidden: !showAdd,
                position: "row",
                onClick: (event: any) => handleOpenDialog(code),
              }),
              ({ showDelete, code }) => ({
                icon: () => <DeleteIcon color="action" />,
                tooltip: Labels.DELETE,
                hidden: !showDelete,
                position: "row",
                onClick: () => deleteFileGroup(code),
              }),
              ({ showSync, code }) => ({
                icon: () => <SyncIcon color="action" />,
                tooltip: "reuse files from previous revisions",
                hidden: !showSync,
                position: "row",
                onClick: () => reuseFilesFromOldRevision(code),
              }),
            ]}
            title={
              <Grid container>
                <Typography>{Labels.MANUSCRIPT_FIGURES}</Typography>
                <HtmlTooltip title={manuscriptFigures} interactive>
                  <HelpOutlineIcon fontSize="small" className={classes.helpIcon} />
                </HtmlTooltip>
              </Grid>
            }
          />
          <div className={classes.buttons}>
            <Button
              onClick={submit}
              color="primary"
              variant="contained"
              className={classes.button}
              disabled={
                !(letterOfRebutalDisable && markedManuscriptDisable && unmarkedManuscriptDisable && checkAllRelevantDoc)
              }
            >
              {Labels.SUBMIT}
            </Button>
          </div>
        </Paper>
        <Formik
          enableReinitialize
          initialValues={{
            designation: selectedDesigantion,
            size: "",
            type: "",
            comments: "",
          }}
          onSubmit={() => {}}
        >
          {({ handleBlur, values, touched, errors, handleChange, handleSubmit, setFieldValue }) => (
            <Form>
              <Dialog open={openDialog} onClose={handleCloseDialog} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{Labels.FILE_UPLOAD}</DialogTitle>
                <DialogContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={designationOptions}
                        getOptionLabel={(option: any) => option.name}
                        value={values.designation}
                        disabled
                        onChange={(event, value) => setFieldValue("designation", value)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            margin="normal"
                            id="designation"
                            name="designation"
                            onBlur={handleBlur}
                            label={Labels.FILE_DESIGNATION}
                            error={touched.designation && Boolean(errors.designation)}
                            helperText={touched.designation && errors.designation}
                            fullWidth
                          />
                        )}
                      />
                    </Grid>
                    <DropzoneArea
                      dropzoneProps={{ disabled: !values.designation }}
                      acceptedFiles={handleFileType(values.designation?.code)}
                      maxFileSize={SIZE_1MB * 50} //50MB
                      onChange={(files: File[]) => {
                        if (files.length > 0) {
                          handleResetDialog(
                            true,
                            setFieldValue,
                            files,
                            (files[0].size / SIZE_1MB).toFixed(2) + " mb",
                            getTypeFromNameFile(files[0].name)
                          );
                        }
                      }}
                      onDelete={(file: File) => {
                        handleResetDialog(false, setFieldValue, null, "", "");
                      }}
                      filesLimit={1}
                    />
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        margin="normal"
                        id="size"
                        name="size"
                        onBlur={handleBlur}
                        label={Labels.SIZE}
                        value={values.size}
                        error={touched.size && Boolean(errors.size)}
                        helperText={touched.size && errors.size}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        margin="normal"
                        id="type"
                        name="type"
                        label={`${Labels.FILE_TYPE}:`}
                        value={values.type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.type && Boolean(errors.type)}
                        helperText={touched.type && errors.type}
                        fullWidth
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        id="comments"
                        name="comments"
                        onBlur={handleBlur}
                        label={Labels.COMMENTS}
                        error={touched.comments && Boolean(errors.comments)}
                        helperText={touched.comments && errors.comments}
                        fullWidth
                        multiline
                        rows={5}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleCloseDialog();
                      handleResetDialog(false, setFieldValue, [], "", "");
                    }}
                    color="primary"
                  >
                    {Labels.CANCEL}
                  </Button>
                  <Button
                    disabled={uploading}
                    onClick={() => {
                      uploadFile(files, values);
                      handleResetDialog(false, setFieldValue, null, "", "");
                      handleCloseDialog();
                    }}
                    color="primary"
                    variant={"contained"}
                  >
                    {Labels.UPLOAD}
                  </Button>
                </DialogActions>
              </Dialog>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
